export const API_CODES: Record<number, string> = {
  400: "Bad Request. Please check the input data.",
  401: "Unauthorized. Please log in again.",
  403: "Access Denied. You don't have permission to perform this action.",
  404: "Resource not found.",
  409: "Conflict detected. The data might already exist.",
  500: "Internal Server Error. Please try again later.",
};